{
	"accesso_id": {
		"type": "object",
		"title": "1501_accesso_id__t",
		"description": "1501_accesso_id__d",
		"required": ["enable"],
		"properties": {
			"enable": {
				"type": "boolean",
				"default": false,
				"title": "1501_accesso_id_enable__t",
				"description": "1501_accesso_id_enable__d"
			},
			"show_legacy_option": {
				"type": "boolean",
				"title": "1501_accesso_id_login__t",
				"description": "1501_accesso_id_login__d",
				"default": true
			}
		}
	},
	"accessoPay": {
		"type": "object",
		"minLength": 1,
		"title": "1501_acspay__t",
		"description": "1501_acspay__d",
		"required": ["enable"],
		"properties": {
			"enable": {
				"type": "boolean",
				"default": false,
				"title": "1501_acspay_e__t",
				"description": "1501_acspay_e__d"
			},
			"requireDemographics": {
				"type": "boolean",
				"default": true,
				"title": "1501_acspay_require_demographics__t",
				"description": "1501_acspay_require_demographics__d"
			},
			"tenant": {
				"type": "string",
				"title": "1501_acspay_t__t",
				"description": "1501_acspay_t__d"
			},
			"merchantId": {
				"type": "number",
				"title": "1501_acspay_m__t",
				"description": "1501_acspay_m__d"
			},
			"merchantOverrideParam": {
				"type": "string",
				"title": "1501_acspay_mop__t",
				"description": "1501_acspay_mop__d"
			},
			"language": {
				"type": "string",
				"title": "1501_acspay_l__t",
				"description": "1501_acspay_l__d"
			},
			"scriptUrl": {
				"type": "string",
				"title": "1501_acspay_s__t",
				"description": "1501_acspay_s__d"
			},
			"disableCardTypes": {
				"type": "array",
				"title": "1501_acspay_dct__t",
				"description": "1501_acspay_dct__d",
				"items": {
					"enum": [
						"visa",
						"mastercard",
						"americanexpress",
						"discover",
						"chinaunionpay",
						"dinersclub",
						"carteblanche",
						"jcb",
						"enroute",
						"jal",
						"maestroukdomestic",
						"nicoshousecard",
						"visadelta",
						"visaelectron",
						"dankort",
						"cartesbancaires",
						"cartasi",
						"uatp",
						"maestrointernational",
						"hipercard",
						"aura",
						"oricohousecard",
						"orico",
						"elo",
						"rupay"
					],
					"type": "string"
				}
			},
			"disablePaymentTypes": {
				"type": "array",
				"title": "1501_acspay_dpt__t",
				"description": "1501_acspay_dpt__d",
				"items": {
					"enum": [
						"applepay",
						"googlepay",
						"wechatpay",
						"paypal",
						"grabpay",
						"naverpay",
						"kakaopay",
						"koreancyberpayments",
						"giropay",
						"wechatpayqr",
						"alipay",
						"alipayhk",
						"giftcard",
						"ideal",
						"bancontactdesktop",
						"bancontactmobile",
						"sofort"
					],
					"type": "string"
				}
			}
		}
	},
	"adyenClientKey": {
		"type": "string",
		"minLength": 1,
		"title": "1501_adyen__t",
		"description": "1501_adyen__d"
	},
	"allow_lock_out_access": {
		"type": "boolean",
		"title": "1501_aloa__t",
		"description": "1501_aloa__d"
	},
	"assetsPath": {
		"type": "string",
		"minLength": 5,
		"title": "1501_ap__t",
		"description": "1501_ap__d"
	},
	"bookings": {
		"_internalName": "Booking Portal Configuration",
		"$id": "1501_booking_portal",
		"description": "1501_b_prtl__d",
		"properties": {
			"accessoPay": {
				"type": "object",
				"minLength": 1,
				"title": "1501_bookings_acspay__t",
				"description": "1501_bookings_acspay__d",
				"required": ["enable"],
				"properties": {
					"enable": {
						"type": "boolean",
						"default": false,
						"title": "1501_acspay_e__t",
						"description": "1501_acspay_e__d"
					},
					"requireDemographics": {
						"type": "boolean",
						"default": true,
						"title": "1501_acspay_require_demographics__t",
						"description": "1501_acspay_require_demographics__d"
					},
					"tenant": {
						"type": "string",
						"title": "1501_acspay_t__t",
						"description": "1501_acspay_t__d"
					},
					"merchantId": {
						"type": "number",
						"title": "1501_acspay_m__t",
						"description": "1501_acspay_m__d"
					},
					"merchantOverrideParam": {
						"type": "string",
						"title": "1501_acspay_mop__t",
						"description": "1501_acspay_mop__d"
					},
					"language": {
						"type": "string",
						"title": "1501_acspay_l__t",
						"description": "1501_acspay_l__d"
					},
					"scriptUrl": {
						"type": "string",
						"title": "1501_acspay_s__t",
						"description": "1501_acspay_s__d"
					},
					"disableCardTypes": {
						"type": "array",
						"title": "1501_acspay_dct__t",
						"description": "1501_acspay_dct__d",
						"items": {
							"enum": [
								"visa",
								"mastercard",
								"americanexpress",
								"discover",
								"chinaunionpay",
								"dinersclub",
								"carteblanche",
								"jcb",
								"enroute",
								"jal",
								"maestroukdomestic",
								"nicoshousecard",
								"visadelta",
								"visaelectron",
								"dankort",
								"cartesbancaires",
								"cartasi",
								"uatp",
								"maestrointernational",
								"hipercard",
								"aura",
								"oricohousecard",
								"orico",
								"elo",
								"rupay"
							],
							"type": "string"
						}
					},
					"disablePaymentTypes": {
						"type": "array",
						"title": "1501_acspay_dpt__t",
						"description": "1501_acspay_dpt__d",
						"items": {
							"enum": [
								"applepay",
								"googlepay",
								"wechatpay",
								"paypal",
								"grabpay",
								"naverpay",
								"kakaopay",
								"koreancyberpayments",
								"giropay",
								"wechatpayqr",
								"alipay",
								"alipayhk",
								"giftcard",
								"ideal",
								"bancontactdesktop",
								"bancontactmobile",
								"sofort"
							],
							"type": "string"
						}
					}
				}
			},
			"enableBookings": {
				"description": "1501_b_prtl_enabks__d",
				"title": "1501_b_prtl_enabks__t",
				"type": "boolean"
			},
			"enable_booking_upgrades": {
				"description": "1501_enable_booking_upgrades__d",
				"title": "1501_enable_booking_upgrades__t",
				"type": "boolean"
			},
			"enable_booking_upgrade_terms_and_conditions": {
				"description": "1501_enable_booking_upgrades_t_and_c__d",
				"title": "1501_enable_booking_upgrades_t_and_c__t",
				"type": "boolean"
			},
			"bypass_booking_upgrade_terms_and_conditions_for_even_price_exchanges": {
				"description": "1501_bypass_booking_upgrades_t_and_c_for_even_price_exchanges__d",
				"title": "1501_bypass_booking_upgrades_t_and_c_for_even_price_exchanges__t",
				"type": "boolean"
			},
			"email_receipt_all_booking_modifications": {
				"description": "1501_booking_send_receipt_all_mods__d",
				"title": "1501_booking_send_receipt_all_mods__t",
				"type": "boolean"
			},
			"booking_tax_inclusive_pricing": {
				"description": "1501_b_prtl_tax_inclusive_pricing__d",
				"title": "1501_b_prtl_tax_inclusive_pricing__t",
				"type": "boolean"
			},
			"capture_prompt_email_list": {
				"additionalItems": false,
				"description": "1501_b_prtl_capt_prmpt_email__d",
				"title": "1501_b_prtl_capt_prmpt_email__t",
				"items": {
					"type": "string"
				},
				"type": "array"
			},
			"display_modifications_remaining": {
				"description": "1501_b_prtl_disp_mod_remaining__d",
				"title": "1501_b_prtl_disp_mod_remaining__t",
				"type": "boolean"
			},
			"display_zero_capacity": {
				"description": "1501_b_prtl_disp_zero_capacity__d",
				"title": "1501_b_prtl_disp_zero_capacity__t",
				"type": "boolean"
			},
			"enableCancellation": {
				"_internalDescription": "Enables the Cancellation Reservation feature for Booking Portal",
				"_internalName": "Enable Cancellations",
				"description": "1501_b_prtl_enabc__d",
				"title": "1501_b_prtl_enabc__t",
				"type": "boolean",
				"default": true
			},
			"enableEmailItinerary": {
				"_internalDescription": "Enables the Email Itinerary feature for Booking Portal",
				"_internalName": "Enable Email Itinerary",
				"description": "1501_b_prtl_enabe__d",
				"title": "1501_b_prtl_enabe__t",
				"type": "boolean"
			},
			"enableViewTickets": {
				"_internalDescription": "Enables the View Tickets feature for Booking Portal",
				"_internalName": "Enable View Tickets",
				"description": "1501_b_prtl_enabv__d",
				"title": "1501_b_prtl_enabv__t",
				"type": "boolean"
			},
			"experience_options": {
				"description": "1501_b_prtl_xp_opt__d",
				"properties": {
					"enable_conflict_resolution": {
						"description": "1501_b_prtl_xp_opt_enbl_cnflt_res__d",
						"title": "1501_b_prtl_xp_opt_enbl_cnflt_res__t",
						"type": "boolean"
					},
					"vendor_time_buffers": {
						"additionalItems": false,
						"description": "1501_b_prtl_xp_opt_vend_t_b__d",
						"items": {
							"properties": {
								"buffer_minutes": {
									"description": "1501_b_prtl_xp_opt_vend_t_b_min__d",
									"type": "number"
								},
								"vendor_id_1": {
									"description": "1501_b_prtl_xp_opt_vend_t_b_id_1__d",
									"type": "string"
								},
								"vendor_id_2": {
									"description": "1501_b_prtl_xp_opt_vend_t_b_id_2__d",
									"type": "string"
								}
							},
							"required": ["buffer_minutes", "vendor_id_1", "vendor_id_2"],
							"type": "object"
						},
						"title": "1501_b_prtl_xp_opt_vend_t_b__t",
						"type": "array"
					}
				},
				"title": "1501_b_prtl_xp_opt__t",
				"type": "object"
			},
			"mode": {
				"description": "1501_b_prtl_mode__d",
				"title": "1501_b_prtl_mode__t",
				"enum": ["default", "group_reservation"],
				"type": "string"
			},
			"show_free_days_label": {
				"description": "1501_b_prtl_show_free_days_label__d",
				"title": "1501_b_prtl_show_free_days_label__t",
				"type": "boolean"
			}
		},
		"title": "1501_b_prtl__t",
		"type": "object"
	},
	"contract_viewer": {
		"type": "object",
		"title": "1501_cv__t",
		"description": "1501_cv__d",
		"required": ["enable", "path"],
		"properties": {
			"enable": {
				"type": "boolean",
				"default": false,
				"title": "1501_cv_e__t",
				"description": "1501_cv_e__d"
			},
			"path": {
				"type": "string",
				"minLength": 1,
				"title": "1501_cv_p__t",
				"description": "1501_cv_p__d"
			},
			"enable_new_contract_viewer": {
				"type": "boolean",
				"default": false,
				"title": "1501_cv_new__t",
				"description": "1501_cv_new__d"
			}
		}
	},
	"css_variables": {
		"_internalName": "CSS Variables",
		"$id": "1501_css_variables",
		"description": "1501_css_v__d",
		"properties": {
			"gap-primary": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-primary-lighter": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-primary-darker": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-secondary": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-secondary-lighter": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-secondary-darker": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-tertiary": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-tertiary-lighter": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-tertiary-darker": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-error": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-error-lighter": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-error-darker": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-success": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-success-lighter": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-success-darker": {
				"pattern": "^#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$|^$",
				"type": "string"
			},
			"gap-font-family": {
				"type": "string"
			}
		}
	},
	"currency_code": {
		"type": "string",
		"default": "USD",
		"title": "1501_curr__t",
		"description": "1501_curr__d"
	},
	"cybersource_session_timeout": {
		"type": "number",
		"minimum": 60000,
		"default": 600000,
		"title": "1501_cybs_time__t",
		"description": "1501_cybs_time__d"
	},
	"default_country_code": {
		"type": "string",
		"minLength": 2,
		"maxLength": 2,
		"default": "US",
		"title": "1501_def_c__t",
		"description": "1501_def_c__d"
	},
	"disable_faq_tab": {
		"type": "boolean",
		"default": false,
		"title": "1501_dis_faq__t",
		"description": "1501_dis_faq__d"
	},
	"disable_membership_cancelation": {
		"type": "boolean",
		"default": false,
		"title": "1501_dis_memcancel__t",
		"description": "1501_dis_memcancel__d"
	},
	"disable_membership_pay_off": {
		"default": false,
		"description": "1501_dis_mempayoff__d",
		"title": "1501_dis_mempayoff__t",
		"type": "boolean"
	},
	"disable_membership_tab": {
		"type": "boolean",
		"default": false,
		"title": "1501_dis_memtab__t",
		"description": "1501_dis_memtab__d"
	},
	"disable_min_phone_length": {
		"type": "boolean",
		"default": false,
		"title": "1501_dis_min_p__t",
		"description": "1501_dis_min_p__d"
	},
	"disable_payment_history_tab": {
		"type": "boolean",
		"default": false,
		"title": "1501_dis_payhistab__t",
		"description": "1501_dis_payhistab__d"
	},
	"disable_payment_id": {
		"type": "boolean",
		"default": false,
		"title": "1501_dis_payid__t",
		"description": "1501_dis_payid__d"
	},
	"default_phone_code": {
		"type": "string",
		"minLength": 1,
		"default": 1,
		"title": "1501_def_p__t",
		"description": "1501_def_p__d"
	},
	"disable_zip_code_validation": {
		"type": "boolean",
		"default": false,
		"title": "1501_dis_zip_val__t",
		"description": "1501_dis_zip_val__d"
	},
	"enable_compulsory_payment_details": {
		"type": "boolean",
		"default": false,
		"title": "1501_compulsory_details__t",
		"description": "1501_compulsory_details__d"
	},
	"enable_payments_lock_out_codes": {
		"type": "string",
		"title": "1501_pay_lock_out_codes__t",
		"description": "1501_pay_lock_out_codes__d"
	},
	"enhanced_phone_number": {
		"type": "object",
		"title": "1501_enh_phone__t",
		"description": "1501_enh_phone__d",
		"required": ["use_enhanced_phone_number"],
		"properties": {
			"use_enhanced_phone_number": {
				"type": "boolean",
				"default": false,
				"title": "1501_enh_phone_u__t",
				"description": "1501_enh_phone_u__d"
			},
			"display_with_flags": {
				"type": "boolean",
				"default": false,
				"title": "1501_enh_phone_f__t",
				"description": "1501_enh_phone_f__d"
			}
		}
	},
	"faviconOverride": {
		"type": "string",
		"minLength": 1,
		"title": "1501_favico__t",
		"description": "1501_favico__d"
	},
	"logo": {
		"type": "string",
		"minLength": 1,
		"title": "1501_logo__t",
		"description": "1501_logo__d"
	},
	"merchant_locale_suffix": {
		"type": "string",
		"title": "1501_merlocsuff__t",
		"description": "1501_merlocsuff__d"
	},
	"mfa_resend_code_wait_time": {
		"type": "number",
		"default": 60000,
		"title": "1501_mfaresendwait__t",
		"description": "1501_mfaresendwait__d"
	},
	"navigation_tree_display": {
		"type": "array",
		"items": {
			"enum": ["overview", "membership", "payments", "documents", "booking-portal", "faq", "logout"],
			"type": "string"
		},
		"title": "1501_nav_tree_display__t",
		"description": "1501_nav_tree_display___d"
	},
	"primary_nav_color": {
		"type": "string",
		"pattern": "#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
		"title": "1501_pnc__t",
		"description": "1501_pnc__d"
	},
	"primary_nav_text_color": {
		"type": "string",
		"pattern": "#(?=(?:.{3}|.{6})$)[0-9A-Za-z]*$",
		"title": "1501_pntc__t",
		"description": "1501_pntc__d"
	},
	"print_path": {
		"_internalName": "Print Path Configuration",
		"$id": "1501_prtpa__t",
		"description": "1501_prtpa__d",
		"properties": {
			"development": {
				"type": "string"
			},
			"production": {
				"type": "string"
			},
			"stg": {
				"type": "string"
			},
			"test": {
				"type": "string"
			}
		}
	},
	"receipts": {
		"_internalName": "Receipts Configuration",
		"$id": "1501_receipts",
		"description": "1501_receipts__t",
		"properties": {
			"disable_receipts_nav_item": {
				"type": "boolean",
				"default": false,
				"title": "1501_disablereceipts__t",
				"description": "1501_disablereceipts__d"
			},
			"receipt_tenant": {
				"type": "string",
				"minLength": 1,
				"title": "1501_rect__t",
				"description": "1501_rect__d"
			}
		}
	},
	"reprint_mobile_link": {
		"type": "string",
		"title": "1501_rprtmob__t",
		"description": "1501_rprtmob__d"
	},
	"session_time": {
		"type": "number",
		"minimum": 180000,
		"default": 1800000,
		"title": "1501_st__t",
		"description": "1501_st__d"
	},
	"show_payment_history_footer": {
		"type": "boolean",
		"default": false,
		"title": "1501_show_his_fot_t",
		"description": "1501_show_his_fot_d"
	},
	"supported_languages": {
		"type": "string",
		"title": "1501_sl__t",
		"description": "1501_sl__d"
	},
	"supportNumber": {
		"type": "string",
		"title": "1501_supportnumber__t",
		"description": "1501_supportnumber__d"
	},
	"sw_ticket_usage_refresh_time": {
		"type": "number",
		"default": 15000,
		"minimum": 5000,
		"maximum": 60000,
		"title": "1501_sw_refresh_time__t",
		"description": "1501_sw_refresh_time__d"
	}
}
